import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  clearComponentByIdMultilingual,
  getComponentByIdMultilingual,
} from '@wajeez-web/stores/content';
import { useNavigate } from 'react-router-dom';
import { useGetComponentByIdMultilingual } from '@wajeez-web/components/helpers';

import { ComponentForm } from '../components/ComponentForm';

export const EditComponentPage = () => {
  const { flowId, pageId, componentId } = useParams<{
    flowId: string;
    pageId: string;
    componentId: string;
  }>();

  const navigate = useNavigate();

  const { data: componentDetailsMultilingualData } =
    useGetComponentByIdMultilingual();

  useEffect(() => {
    componentId && getComponentByIdMultilingual(componentId);

    return () => {
      clearComponentByIdMultilingual();
    };
  }, [componentId]);

  return (
    <div>
      <ComponentForm
        type="Edit"
        onSubmit={() => {
          navigate(`/flows/${flowId}/pages/${pageId}`);
        }}
        onItemTemplateCloneSaveAndEdit={(itemTemplateId) => {
          navigate(
            `/flows/${flowId}/pages/${pageId}/components/${itemTemplateId}/edit`
          );
        }}
        onItemTemplateEditButtonClick={(itemTemplateId) => {
          navigate(
            `/flows/${flowId}/pages/${pageId}/components/${itemTemplateId}/edit`
          );
        }}
        componentTypeId={componentDetailsMultilingualData?.typeId?.toString()}
        onCancel={() => {
          navigate(`/flows/${flowId}/pages/${pageId}`);
        }}
      />
    </div>
  );
};
